import * as React from 'react';

import { Layout } from 'antd';
import { Notification, Space, Row } from 'farmhub-ui-core';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';

import { useAppSelector, useAppDispatch } from 'app';
import {
  ElectronicBillModal,
  HeaderMainNavbar,
  PartnerNoteModal,
} from 'components';
import AppBreadcrumb from 'components/Layout/AppBreadcrumb';
import Logo from 'components/Layout/Logo';
import ViewVideoModal from 'components/Modal/ViewVideoModal';
import MenuSkeleton from 'components/Skeleton/MenuSkeleton';
import AccountModal from 'containers/App/Account/AccountModal';
import LoadingProcessUpdateStatusChainOrder from 'containers/WarehouseOperation/OperationalSetting/SettingPage/components/LoadingProcessUpdateStatusChainOrder';
import LoadingProcessUpdateStatus from 'containers/WarehouseOperation/OrderOperation/Balance/components/LoadingProcessUpdateStatus';
import OrderTaskModal from 'containers/WarehouseOperation/WorkSpace/components/OrderTaskModal';
import { useLocalStorage } from 'hooks';
import {
  clearData,
  findOneAutoOrderSettingWithEntity,
  findEntityCategoryWithEntity,
  findEntityRelativeQuantity,
  getProposalItemCount,
  logout,
  saveRoute,
  selectAccount,
  selectAppDevice,
  updateMenuToggle,
  findOneAutoForecastSettingWithEntity,
  cancelVideoModal,
  selectVideo,
  findEntityDocumentSubCategory,
  updateInitLoad,
  findEntityMaterialCategoryWithEntity,
  findUserPermissions,
  findEntityRole,
} from 'slice';
import { GlobalStyle } from 'styled';
import { SELECTED_ENTITY } from 'types';
import {
  ACTIVE_STATUS,
  checkPermission,
  DEVICES,
  FILTER_SETTING_BALANCE_TABLE,
  INIT_ORDER_SETTING_BALANCE,
  INIT_SALE_ACTIVE_TAB,
  OrderSettingBalance,
  SALE_TAB_TYPE,
  SaleActiveTab,
  SETTING_VIEW_MODE_TYPE,
} from 'utils';

import { AppMobile } from './AppMobile/Loadable';
import { BackMenu, CollapseButton, MenuItem, MenuTitle } from './components';
import * as S from './Styles';
import { getDataMenuSystem } from './utils/function';
import { routes } from './utils/route';

export function App() {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const appDevice = useAppSelector(selectAppDevice);
  const user = useAppSelector(state => state.auth.item);
  const video = useAppSelector(selectVideo);
  const account = useAppSelector(selectAccount);
  const entityID = useAppSelector(state => state.account.item?.id);
  const canCreateNewProduct = useAppSelector(
    state => state.account.item?.canCreateNewProduct
  );
  const selectedEntity = localStorage.getItem(SELECTED_ENTITY);
  const { type: entityType } = JSON.parse(selectedEntity || '{}');
  // 0: 'user', 1: 'farm', 2: 'store', 3: 'collaborator', 4: 'warehouse', 5: 'transport', 6: 'volunteer'
  const [settingOrderLocal, setSettingOrderLocal] =
    useLocalStorage<OrderSettingBalance>(
      `${FILTER_SETTING_BALANCE_TABLE}_${entityID}_order_filter_setting`,
      INIT_ORDER_SETTING_BALANCE
    );
  const [saleActiveTab, setSaleActiveTab] = useLocalStorage<SaleActiveTab>(
    `${entityID}_sale_active_tab`,
    INIT_SALE_ACTIVE_TAB
  );

  const [prevRoute, setPrevRoute] = React.useState('');
  const [menuActive, setMenuActive] = React.useState('');
  const [currentDataMenu, setCurrentDataMenu] = React.useState<any>(
    getDataMenuSystem({
      accountItem: account.item,
      isCentralEntity: account.item?.isCentral,
      permissions: account.permissions,
    })
  );

  const [height, setHeight] = React.useState<string>('calc(100vh - 0px)');

  React.useLayoutEffect(() => {
    const initTheme = () => {
      const vh = window.innerHeight;
      setHeight(`${vh - 0}px`);

      dispatch(updateInitLoad());
    };

    initTheme();
  }, []);

  const handleWindowResize = () => {
    if (window.innerWidth >= 1450) {
      dispatch(updateMenuToggle(true));
    } else {
      dispatch(updateMenuToggle(false));
    }
  };

  const handleLogoutUser = async () => {
    try {
      await dispatch(logout());
      clearData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectMenu = (item: any, layer?: number) => {
    if (item.name === 'Bán tại quầy') {
      setSaleActiveTab({
        id: '',
        type: SALE_TAB_TYPE.CREATE_BILL,
        name: 'Hoá đơn: #1',
        data: {},
      });
    }

    if (item.name === 'Bán tại kho') {
      setSaleActiveTab({
        id: '',
        type: SALE_TAB_TYPE.CREATE_ORDER,
        name: 'Đơn hàng: #1',
        data: {},
      });
    }
    history.push(item.link);
    dispatch(saveRoute(item.link));

    if (layer == 2 && item.layer != 3 && item.subMenu.length === 0) {
      setPrevRoute(item.link);
    }

    if (item.subMenu.length === 0) {
      setMenuActive(item.link);
      return;
    }

    setMenuActive(item.link);
    setCurrentDataMenu(item.subMenu);
  };

  React.useEffect(() => {
    const initCountEntityCart = async () => {
      try {
        await dispatch(
          getProposalItemCount({
            where: {
              customerID: account.item?.id,
              customerStatus: 0,
              supplierStatus: 0,
              customerQuantity: { gt: 0 },
            },
          })
        ).unwrap();
      } catch (error: any) {
        console.log(
          'An error occurred while finding entity cart item count',
          error
        );
      }
    };

    const getEntityRelativeQuantity = async () => {
      try {
        const query: any = {
          ownerID: account.item?.id,
          status: ACTIVE_STATUS.ACTIVATED,
          isDefault: true,
          order: {
            createdAt: 0,
          },
        };
        await dispatch(findEntityRelativeQuantity(query)).unwrap();
      } catch (error: any) {
        console.log(error);
      }
    };

    const getUserPermissions = async () => {
      try {
        await dispatch(findUserPermissions()).unwrap();
      } catch (error: any) {
        // if ([422].includes(error?.statusCode ?? error?.code)) {
        //   history.push('/account/list');
        //   localStorage.removeItem(SELECTED_ENTITY);
        //   window.location.reload();
        // }
      }
    };

    const getEntityRole = async () => {
      try {
        const { data, pagination }: any = await dispatch(
          findEntityRole({})
        ).unwrap();
      } catch (error) {
        console.log(error);
      }
    };

    if (account.item?.id) {
      initCountEntityCart();
      getEntityRelativeQuantity();
      getUserPermissions();
      getEntityRole();
    }
  }, [account.item, dispatch]);

  const formatPath = (path: string) => {
    switch (true) {
      case path.includes('/section/create'): {
        const newPath = path.replace('/section/create', '');
        return newPath.slice(0, newPath.lastIndexOf('/'));
      }

      case path.includes('/section/update/'): {
        const newPath = path.replace('/section/update/', '');
        return newPath.slice(0, newPath.lastIndexOf('/'));
      }

      case path.includes('/create'): {
        return path.replace('/create', '');
      }

      case path.includes('/purchase-order-draft') && path.includes('/detail'): {
        const newPath = path.replace('/detail', '');
        return newPath
          .slice(0, newPath.lastIndexOf('/'))
          .replace('/purchase-order-draft', '');
      }

      case path.includes('/purchase-order-draft'): {
        return path.replace('/purchase-order-draft', '');
      }

      case path.includes('/entity-material-category/list'): {
        return path.replace('/entity-material-category/list', '');
      }

      case path.includes('/sale-order-draft') && path.includes('/detail'): {
        const newPath = path.replace('/detail', '');
        return newPath
          .slice(0, newPath.lastIndexOf('/'))
          .replace('/sale-order-draft', '');
      }

      case path.includes('/sale-order-draft'): {
        return path.replace('/sale-order-draft', '');
      }

      case path.includes('/sync-menu'): {
        return path.replace('/sync-menu', '');
      }

      case path.includes('/sync'): {
        return path.replace('/sync', '');
      }

      case path.includes('/crm'): {
        const newPath = path.replace('/crm', '');
        return newPath.slice(0, newPath.lastIndexOf('/'));
      }

      case path.includes('/detail') && !path.includes('marketing'): {
        const newPath = path.replace('/detail', '');
        return newPath.slice(0, newPath.lastIndexOf('/'));
      }

      case path.includes('/history') &&
        path.includes('buying-setting') &&
        !path.includes('product') &&
        !path.includes('marketing'): {
          return path.replace('/history', '');
        }

      case path.includes('/detail') && path.includes('product'): {
        const newPath = path.replace('/detail', '');
        return newPath.slice(0, newPath.lastIndexOf('/')).concat('/list');
      }
      // case path.includes('/marketing'): {
      //   return `/marketing`;
      // }
      default:
        return path;
    }
  };

  const handleSetMenuActive = (path: string) => {
    const newPath = formatPath(path);

    if (newPath === `/`) {
      setMenuActive(path);
    } else {
      setMenuActive(newPath);
    }
  };

  const handleBackMenu = (layer: number) => {
    if (layer === 3) {
      history.push(prevRoute);
      return;
    }
    history.push(`/`);
  };

  const renderMenu = () => {
    const result: any = [];
    let menuFilter: any;

    if (currentDataMenu[0].layer !== 1) {
      result.push(
        <BackMenu
          isToggle={account.isToggle}
          onClick={() => handleBackMenu(currentDataMenu[0].layer)}
        />
      );
    }

    for (let i = 0; i < currentDataMenu.length; i += 1) {
      if (account.isToggle && !currentDataMenu[i].hidding) {
        result.push(
          <>
            {i !== 0 && <Space height={4} />}
            <MenuTitle title={currentDataMenu[i].title} />
          </>
        );
      }

      for (let j = 0; j < currentDataMenu[i].menu?.length; j += 1) {
        const menuItem = currentDataMenu[i].menu[j];
        if (!menuItem.hidding && !currentDataMenu[i].hidding) {
          result.push(
            <MenuItem
              isToggle={account.isToggle}
              menuActive={menuActive}
              menuItem={menuItem}
              onClick={() =>
                handleSelectMenu(menuItem, currentDataMenu[i].layer)
              }
            />
          );
        }
      }
    }

    if (menuFilter) {
      result.push(menuFilter);
    }

    return result;
  };

  const renderOriginDataMenu = (entityType: number) => {
    if (account.item?.id) {
      switch (entityType) {
        case 1:
          return getDataMenuSystem({
            accountItem: account.item,
            isCentralEntity: account.item?.isCentral,
            permissions: account.permissions,
          });
        case 2:
          return getDataMenuSystem({
            accountItem: account.item,
            isCentralEntity: account.item?.isCentral,
            permissions: account.permissions,
          });
        case 3:
          return getDataMenuSystem({
            accountItem: account.item,
            isCentralEntity: account.item?.isCentral,
            permissions: account.permissions,
          });
        default:
          return '';
      }
    }
    return [];
  };

  React.useEffect(() => {
    const handleInvalidToken = e => {
      if (e.key === 'USER_ID') {
        if (e.oldValue && !e.newValue) {
          dispatch(logout());
        }

        if (e.oldValue && e.newValue && e.oldValue !== e.newValue) {
          history.push('/account/list');
          localStorage.removeItem(SELECTED_ENTITY);
          window.location.reload();
        }
      }
    };
    window.addEventListener('storage', handleInvalidToken);
    return function cleanup() {
      window.removeEventListener('storage', handleInvalidToken);
    };
  }, [dispatch, logout]);

  React.useLayoutEffect(() => {
    handleWindowResize();
  }, []);

  React.useLayoutEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  React.useEffect(() => {
    const initMenuData = (initDataMenu: any) => {
      const currentPath = location.pathname;
      handleSetMenuActive(currentPath);
      for (let i = 0; i < initDataMenu.length; i += 1) {
        for (let j = 0; j < initDataMenu[i].menu.length; j += 1) {
          const menuItem = initDataMenu[i].menu[j];

          if (
            (menuItem?.groupLink &&
              menuItem?.groupLink.includes(formatPath(currentPath))) ||
            (initDataMenu[i]?.groupLink &&
              initDataMenu[i]?.groupLink.includes(formatPath(currentPath))) ||
            menuItem.link == formatPath(currentPath)
          ) {
            if (menuItem.subMenu.length === 0) {
              setCurrentDataMenu(initDataMenu);
              return;
            }
            setCurrentDataMenu(menuItem.subMenu);
            return;
          }

          if (location.pathname.includes('/settings')) {
            setCurrentDataMenu(initDataMenu);
          } else {
            initMenuData(menuItem.subMenu);
          }
        }
      }
    };

    if (account.item?.id) {
      const initDataMenu = renderOriginDataMenu(entityType);
      initMenuData(initDataMenu);
    }
  }, [account.item, user?.id, location, account.permissions]); //eslint-disable-line

  React.useEffect(() => {
    const initData = async () => {
      try {
        const standardQuery = {
          id: account.item?.id,
          isRelationWithEntitySubCategory: true,
          isAllStatus: true,
        };

        dispatch(findEntityCategoryWithEntity(standardQuery));
        dispatch(findEntityMaterialCategoryWithEntity(standardQuery));
        dispatch(findEntityDocumentSubCategory({}));
      } catch (error: any) {
        if (![422, 403].includes(error?.statusCode ?? error?.code)) {
          Notification(
            'error',
            'Tải dữ liệu thất bại',
            error,
            appDevice.device
          );
        }
      }
    };
    if (account.item?.id) {
      initData();
    }
  }, [account.item?.id, dispatch]);

  React.useEffect(() => {
    const initAutoOrderSetting = async (): Promise<void> => {
      try {
        await dispatch(findOneAutoOrderSettingWithEntity()).unwrap();
      } catch (error: any) {
        console.log('error while getting auto order setting!');
      }
    };
    if (
      account.item?.id &&
      checkPermission({
        permissions: account.permissions,
        module: 'setting',
        groupFeature: 'settingOperation',
        feature: 'settingOperationAutoOrder',
      })
    ) {
      initAutoOrderSetting();
    }
  }, [account.permissions, dispatch]);

  React.useEffect(() => {
    const initAutoForecastSetting = async (): Promise<void> => {
      try {
        await dispatch(findOneAutoForecastSettingWithEntity()).unwrap();
      } catch (error: any) {
        console.log('error while getting auto forecast setting!');
      }
    };
    if (
      account.item?.id &&
      checkPermission({
        permissions: account.permissions,
        module: 'setting',
        groupFeature: 'settingOperation',
        feature: 'settingOperationAutoForecast',
      })
    ) {
      initAutoForecastSetting();
    }
  }, [account.permissions, dispatch]);

  const ref: any = React.useRef(null);

  const hideMenu = React.useMemo(
    () =>
      location.pathname.includes('/settings/price-policy/overview') ||
      location.pathname.includes('/partner/overview') ||
      location.pathname.includes('/supplier/overview') ||
      location.pathname == '/sale/' ||
      location.pathname.includes('/sale/balance') ||
      location.pathname.includes('/production-plan/report-quantity') ||
      location.pathname.includes('/production-plan/task') ||
      location.pathname.includes('/purchase/order-chain-supplier') ||
      location.pathname.includes('/settings/blog/create') ||
      (location.pathname.includes('/settings/blog/') &&
        location.pathname.includes('/detail')) ||
      location.pathname.includes('/sale/quick-forecast'),
    [location.pathname, appDevice.device]
  );

  const hideHeader = React.useMemo(
    () => location.pathname == '/sale/',
    [location.pathname, appDevice.device]
  );

  const title = React.useMemo(() => {
    if (location.pathname.includes('/settings/price-policy/overview')) {
      return 'Tổng quan chính sách giá';
    }
    if (location.pathname.includes('/supplier/overview')) {
      return 'Tổng quan nhà cung cấp';
    }
    if (location.pathname.includes('/partner/overview')) {
      return 'Tổng quan khách hàng';
    }
    if (location.pathname.includes('/sale/#')) {
      return 'Bán hàng';
    }
    if (location.pathname.includes('/sale/balance')) {
      return `Chia hàng (${settingOrderLocal.viewMode.default == SETTING_VIEW_MODE_TYPE.CUSTOMER
          ? 'Chế độ khách hàng'
          : 'Chế độ đơn hàng'
        })`;
    }
    if (location.pathname.includes('/production-plan/report-quantity')) {
      return `Báo cáo sản lượng`;
    }
    if (location.pathname.includes('/production-plan/task')) {
      return `Công nhật`;
    }
    if (location.pathname.includes('/purchase/order-chain-supplier')) {
      return 'Đặt hàng';
    }
    if (location.pathname.includes('/settings/blog/create')) {
      return 'Tạo bài viết';
    }
    if (
      location.pathname.includes('/settings/blog/') &&
      location.pathname.includes('/detail')
    ) {
      return 'Cập nhật bài viết';
    }
    return '';
  }, [location.pathname, appDevice.device, settingOrderLocal.viewMode.default]);

  const handleToggleMenu = () => {
    dispatch(updateMenuToggle(!account.isToggle));
  };

  const syncStatusComponent = React.useMemo(() => {
    if (location.pathname.includes('/sale/balance')) {
      return <LoadingProcessUpdateStatus />;
    }
    if (location.pathname.includes('/production-plan/report-quantity')) {
      return <LoadingProcessUpdateStatus />;
    }
    if (location.pathname.includes('/production-plan/task')) {
      return <LoadingProcessUpdateStatus />;
    }
    if (location.pathname.includes('/purchase/order-chain-supplier')) {
      return <LoadingProcessUpdateStatusChainOrder />;
    }

    return <></>;
  }, [location.pathname]);

  return (
    <S.Wrapper
      height={height}
      id="container"
      isMobile={appDevice.device == DEVICES.MOBILE}
    >
      <PartnerNoteModal />
      <ElectronicBillModal />
      <OrderTaskModal />
      <ViewVideoModal
        url={video.data}
        visible={video.visible}
        onCancel={() => {
          dispatch(cancelVideoModal());
        }}
      />
      {!hideMenu && appDevice.device == DEVICES.DESKTOP && (
        <S.WrapperMenu ref={ref} isToggle={account.isToggle}>
          <S.HeadWrapper>
            <Row
              alignItems="center"
              height="57px"
              styles={{ padding: '0px 12px' }}
            >
              <Logo
                isExpand={account.isToggle}
                onRedirect={() => {
                  history.push(`/`);
                }}
              />
            </Row>
            <AccountModal height={48} isToggle={account.isToggle} />
          </S.HeadWrapper>
          <S.ContentMenu className="overlay" id="content-menu">
            <S.CMenu>
              {account.isSelectedAccount ? <MenuSkeleton /> : renderMenu()}
            </S.CMenu>
          </S.ContentMenu>
          <CollapseButton
            isToggle={account.isToggle}
            onClick={handleToggleMenu}
          />
        </S.WrapperMenu>
      )}
      <Layout
        style={{
          width:
            hideMenu || appDevice.device == DEVICES.MOBILE
              ? '100%'
              : `calc(100vw - ${account.isToggle ? '246px' : '94px'})`,
          background: '#F2F3F7',
          position: 'relative',
        }}
      >
        {appDevice.device == DEVICES.DESKTOP && !hideHeader && (
          <HeaderMainNavbar
            breadcrumb={<AppBreadcrumb />}
            hideMenu={hideMenu}
            syncStatus={syncStatusComponent}
            title={title}
            user={user}
            onLogoutUser={handleLogoutUser}
          />
        )}
        <S.WrapperContent
          isChatPage={location.pathname === `/chat`}
          margin={hideMenu ? '0px' : '8px 0px 0px 8px'}
        >
          <S.Content width="100%">
            <Switch>
              {!account.isSelectedAccount &&
                routes(canCreateNewProduct, account?.permissions ?? {})
                  .filter((item: any) => !item.hidding)
                  .map((item: any, index: number) => {
                    if (
                      appDevice.device == DEVICES.MOBILE &&
                      ['/', '/order', '/contact', '/profile'].includes(
                        item.path
                      )
                    ) {
                      return (
                        <Route
                          key={item.path}
                          component={AppMobile}
                          exact={item.exact}
                          path={item.path}
                          render={item.render}
                        />
                      );
                    }

                    return (
                      <Route
                        key={item.path}
                        component={item.component}
                        exact={item.exact}
                        path={item.path}
                        render={item.render}
                      />
                    );
                  })}
              {!account.isSelectedAccount && <Redirect to="/" />}
            </Switch>
          </S.Content>
        </S.WrapperContent>
      </Layout>
      <GlobalStyle />
    </S.Wrapper>
  );
}
